(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AreaSelect", [], factory);
	else if(typeof exports === 'object')
		exports["AreaSelect"] = factory();
	else
		root["AreaSelect"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//import vueAreaSelect from './components/vue-area-select'   //引入组件
//import scroll from './components/scroll1.vue'   //引入组件
//import dates from './components/dates.vue'   //引入组件
// import 'font-awesome/css/font-awesome.css'
var oddsafe = {
  install: function install(Vue, options) {
    //    Vue.component(vueAreaSelect.name, vueAreaSelect) //全局组件
    //    Vue.component(scroll.name, scroll) //全局组件
    //    Vue.component(dates.name, dates) //全局组件
    Vue.prototype.$http = function () {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { method: "GET", http: "http", url: "", data: {}, wait: true, debug: false };
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (obj.http = "http") {
        new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          xhr.open(obj.method, obj.url, obj.wait);
          xhr.send(obj.data);
          xhr.onreadystatechange = function () {
            if (obj.debug) {
              switch (xhr.readyState) {
                case 0:
                  console.log("请求未初始化");
                  break;
                case 1:
                  console.log("服务器连接已建立");
                  break;
                case 2:
                  console.log("请求已接收");
                  break;
                case 3:
                  console.log("请求处理中");
                  break;
                case 4:
                  console.log("请求已完成，且响应已就绪");
                  if (xhr.status == 200) {
                    console.log(xhr.obj);
                    resolve(xhr.obj);
                  } else {
                    reject(xhr);
                  }
                  break;
              }
            } else if (xhr.readyState == 4) {
              if (xhr.status == 200) {
                resolve(xhr.obj);
              } else {
                reject();
              }
            }
          };
        });
      } else {}
    };
  }
};

/* harmony default export */ __webpack_exports__["default"] = (oddsafe); //导出

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// tools.js